export default __webpack_public_path__ + "static/media/Restaurante.f5ce8489.png";